console.log("Script loaded");

// Utility: wait for element using MutationObserver
function waitForElement(selector, timeout = 15000) {
  return new Promise((resolve, reject) => {
    const existing = document.querySelector(selector);
    if (existing) return resolve(existing);

    const observer = new MutationObserver(() => {
      const el = document.querySelector(selector);
      if (el) {
        clearTimeout(timer);
        observer.disconnect();
        resolve(el);
      }
    });

    const timer = setTimeout(() => {
      observer.disconnect();
      reject(new Error(`Element ${selector} not found in ${timeout} ms`));
    }, timeout);

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
  });
}

// Cart operations
async function clearCart() {
  console.log("Clearing cart...");
  const response = await fetch("/cart/clear.js", { method: "POST" });
  const result = await response.json();
  console.log("Cart cleared");
  return result;
}

async function addToShopifyCart(items) {
  console.log("Adding items to cart:", items);
  const response = await fetch("/cart/add.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ items }),
  });
  const result = await response.json();
  console.log("Items added to cart");
  return result;
}

async function getCartData() {
  console.log("Fetching current cart data...");
  const response = await fetch("/cart.js");
  const result = await response.json();
  console.log("Cart data retrieved");
  return result;
}

function compareDatesAsc(a, b) {
  return new Date(a).getTime() - new Date(b).getTime();
}

async function initializeCheckout() {
  try {
    const checkoutButton = await waitForElement("#checkout-button");
    console.log("Checkout button found");

    checkoutButton.addEventListener("click", async () => {
      console.log("Checkout button clicked");



      let hasDomError = false;

      let firstDomError = null;



      document.querySelectorAll(".error-highlight").forEach(el => el.classList.remove("error-highlight"));



      document.querySelectorAll(".address-mobile-no").forEach(block => {
      const addressInput = block.querySelector(".address-input");
      const mobileInput = block.querySelector(".input-mobile-no");
    
      // Address validation
      if (!addressInput || addressInput.value.trim() === "") {
        addressInput?.parentElement?.classList.add("error-highlight");
        if (!firstDomError) firstDomError = addressInput;
        hasDomError = true;
    
        // Remove error class when user types
        addressInput?.addEventListener("input", () => {
          addressInput.parentElement.classList.remove("error-highlight");
        }, { once: true }); // Attach only once
      }
    
      // Mobile validation
      const mobileVal = mobileInput?.value.trim() || "";
      const isValidMobile = /^\d{7,15}$/.test(mobileVal);
    
      if (!mobileInput || mobileVal === "" || !isValidMobile) {
        mobileInput?.parentElement?.classList.add("error-highlight");
        if (!firstDomError) firstDomError = mobileInput;
        hasDomError = true;
    
        // Remove error class when user types
        mobileInput?.addEventListener("input", () => {
          mobileInput.parentElement.classList.remove("error-highlight");
        }, { once: true });
      }
    });




      if (hasDomError) {

        if (firstDomError) {
          firstDomError.scrollIntoView({ behavior: "smooth", block: "center" });
          firstDomError.focus();
        }
        toastr.info("Please fill in all required fields: Address and a valid Mobile Number.");
        checkoutButton.textContent = "Fix Errors to Checkout";
        checkoutButton.disabled = false;
        checkoutButton.classList.remove("processing");
        return;

      }

      try {
        checkoutButton.textContent = "Processing...";
        checkoutButton.disabled = true;
        checkoutButton.classList.add("processing");

        const rawProfiles = localStorage.getItem("profiles");
        if (!rawProfiles) throw new Error("No profile data found");
        console.log("Profile data loaded from localStorage");

        const profiles = JSON.parse(rawProfiles);
        if (!Array.isArray(profiles)) throw new Error("Invalid profile data");
        console.log("Parsed profile data:", profiles);

        let allGroups = [];
        let validationErrors = [];
        let errorElements = [];

        profiles.forEach((profile, profileIndex) => {
          const profileName = profile.name || `Profile ${profileIndex + 1}`;
          const events = profile.events || [];

          if (!events.length) return;

          events.forEach((event, eventIndex) => {
            const eventName = event.event?.name || `Event ${eventIndex + 1}`;
            const dateStr = event.event?.date;
            const address = event.event?.address || "";
            const shipping_cost = event.event?.shipping_cost;
            const products = event.productSelected || [];

            const validProducts = products.filter((p) => p?.variantId);
            if (!validProducts.length) return;

            if (!dateStr || isNaN(new Date(dateStr).getTime())) {
              validationErrors.push(`[${profileName} - ${eventName}] invalid/missing date`);
              errorElements.push(`[data-profile-index="${profileIndex}"][data-event-index="${eventIndex}"] .event-date`);
            }

            if (!address.trim()) {
              validationErrors.push(`[${profileName} - ${eventName}] missing address`);
              errorElements.push(`[data-profile-index="${profileIndex}"][data-event-index="${eventIndex}"] .event-address`);
            }

            if (!profile.mobile || !/^\d{7,15}$/.test(profile.mobile)) {
              validationErrors.push(`[${profileName}] invalid/missing mobile`);
              errorElements.push(`[data-profile-index="${profileIndex}"] .profile-mobile`);
            }

            allGroups.push({
              profileName,
              gender: profile.gender || "unspecified",
              deliveryAddress: address,
              giftnote: profile.giftnote || "",
              receiptNumber: profile.mobile || "",
              shippingCost: shipping_cost,
              eventName,
              eventDateStr: dateStr,
              isSubscription: (eventName || "").toLowerCase().includes("subscription"),
              items: validProducts.map((p) => ({
                name: p.name || "Unnamed Product",
                variantId: p.variantId,
                quantity: Math.max(1, parseInt(p.quantity) || 1),
                price: p.price || "0.00",
              })),
            });
          });
        });

        if (validationErrors.length > 0) {
          console.warn("Validation errors:", validationErrors);
          toastr.info("Please fill in all required fields");

          const firstErrorSelector = errorElements[0];
          if (firstErrorSelector) {
            const el = document.querySelector(firstErrorSelector);
            if (el) {
              el.scrollIntoView({ behavior: "smooth", block: "center" });
              el.classList.add("error-highlight");
              el.focus();
            }
          }

          checkoutButton.textContent = "Fix Errors to Checkout";
          checkoutButton.disabled = false;
          checkoutButton.classList.remove("processing");
          return;
        }

        if (!allGroups.length) throw new Error("No valid events found");

        allGroups.sort((a, b) => compareDatesAsc(a.eventDateStr, b.eventDateStr));
        console.log("Sorted groups by event date");

        const cartItems = [];
        const upcomingEventsData = [];

        allGroups.forEach((group, index) => {
          if (index > 0) {
            const eventData = {
              profileName: group.profileName,
              eventName: group.eventName,
              eventDate: group.eventDateStr,
              deliveryAddress: group.deliveryAddress,
              giftnote: group.giftnote,
              receiptNumber: group.receiptNumber,
              shippingCost: group.shippingCost,
              items: group.items.map((item) => ({
                name: item.name,
                variantId: item.variantId,
                quantity: item.quantity,
                price: parseFloat(item.price).toFixed(2),
                originalPrice: parseFloat(item.originalPrice || item.price).toFixed(2),
                isSubscription: group.isSubscription,
              })),
              "event name": `${group.profileName} - ${group.eventName}`,
              "event date": group.eventDateStr,
            };
            upcomingEventsData.push(eventData);
          }
        });

        const initialGroup = allGroups[0];
        if (initialGroup) {
          initialGroup.items.forEach((item) => {
            const properties = {
              group: "initial_event",
              _group_index: "0",
              _profile_name: initialGroup.profileName,
              _discount: initialGroup.isSubscription ? "100%" : "null",
              event_name: `${initialGroup.profileName} - ${initialGroup.eventName}`,
              event_date: initialGroup.eventDateStr,
              _delivery_address: initialGroup.deliveryAddress,
              _gift_note: initialGroup.giftnote,
              _recipient_number: initialGroup.receiptNumber,
              _shipping_cost: initialGroup.shippingCost,
            };

            cartItems.push({
              id: item.variantId,
              quantity: item.quantity,
              properties,
            });
          });
        }

        const extraItemProperties = {};
        let eventSummaryText = "";

        if (upcomingEventsData.length > 0) {
          const enrichedEventsData = upcomingEventsData.map((event) => {
            const displayEventName = `${event.profileName} - ${event.eventName}`;
            const displayEventDate = new Date(event.eventDate).toLocaleDateString("en-US", {
              year: "numeric",
              month: "long",
              day: "numeric",
            });
            const displayLineitems = event.items.map((item) => item.name).join(", ");
            eventSummaryText += `🎁 ${displayEventName} (${displayEventDate})\nItems: ${displayLineitems}\n\n`;

            return {
              ...event,
              items: event.items.map((item) => ({
                ...item,
                "event name": displayEventName,
                "event date": event.eventDate,
              })),
            };
          });

          extraItemProperties["📝 Event Summary"] = eventSummaryText.trim();
          extraItemProperties._upcoming_events = JSON.stringify(enrichedEventsData);
        }

        cartItems.push({
          id: 50882337997076, // Your extra variant ID
          quantity: 1,
          selling_plan: 690571411732, // Optional
          properties: extraItemProperties,
        });

        console.log("Final cart items to be added:", cartItems);

        await clearCart();
        const finalCartItems = [...cartItems].reverse();
        await addToShopifyCart(finalCartItems);

        const cartData = await getCartData();
        localStorage.setItem("shopifyCart", JSON.stringify(cartData));
        console.log("Cart stored in localStorage");

        checkoutButton.textContent = "Checkout Complete";
        checkoutButton.disabled = false;
        checkoutButton.classList.remove("processing");

        console.log("Redirecting to checkout...");
        window.location.href = "/checkout";

      } catch (error) {
        console.error("Checkout error:", error);
        checkoutButton.textContent = "Checkout Failed";
        checkoutButton.disabled = false;
        checkoutButton.classList.remove("processing");
        alert(`Error: ${error.message}`);
      }
    });

    checkoutButton.disabled = false;
    console.log("Checkout system initialized and button ready");

  } catch (error) {
    console.error("Initialization failed:", error);
    const btn = document.querySelector("#checkout-button");
    if (btn) {
      btn.textContent = "System Error";
      btn.disabled = true;
    }
  }
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initializeCheckout);
} else {
  initializeCheckout();
}

// Style

const style = document.createElement("style");

style.textContent = `

  .error-highlight {
    border: 2px solid red !important;
  }

`;

document.head.appendChild(style);